import React from 'react';
import { MoreVerticalIcon, ArrowRightIcon } from 'lucide-react';
const SubscriptionPlans = () => {
  // This would normally come from an API or state management
  const plans = [{
    name: 'Basic',
    customers: 486,
    percentage: 38,
    mrr: 7290,
    arpu: 15,
    color: 'bg-blue-500'
  }, {
    name: 'Pro',
    customers: 542,
    percentage: 42,
    mrr: 12466,
    arpu: 23,
    color: 'bg-indigo-500'
  }, {
    name: 'Enterprise',
    customers: 256,
    percentage: 20,
    mrr: 4775,
    arpu: 75,
    color: 'bg-purple-500'
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-800">
            Subscription Plans
          </h2>
          <button className="text-gray-400 hover:text-gray-600">
            <MoreVerticalIcon size={20} />
          </button>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-center mb-6">
          <div className="h-4 flex-1 bg-gray-200 rounded-full overflow-hidden">
            {plans.map((plan, index) => <div key={index} className={`h-full ${plan.color}`} style={{
            width: `${plan.percentage}%`
          }}></div>)}
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                <th className="pb-3">Plan</th>
                <th className="pb-3">Customers</th>
                <th className="pb-3">MRR</th>
                <th className="pb-3">ARPU</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {plans.map((plan, index) => <tr key={index}>
                  <td className="py-3">
                    <div className="flex items-center">
                      <div className={`h-3 w-3 rounded-full ${plan.color} mr-3`}></div>
                      <span className="font-medium">{plan.name}</span>
                    </div>
                  </td>
                  <td className="py-3">
                    <div>
                      <span className="font-medium">{plan.customers}</span>
                      <span className="text-gray-500 text-sm ml-1">
                        ({plan.percentage}%)
                      </span>
                    </div>
                  </td>
                  <td className="py-3">
                    <span className="font-medium">
                      ${plan.mrr.toLocaleString()}
                      <span className="text-gray-500 text-sm ml-1">
                        /month
                      </span>
                    </span>
                  </td>
                  <td className="py-3">
                    <span className="font-medium">${plan.arpu}</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
        <button className="flex items-center text-sm text-blue-600 font-medium hover:text-blue-800">
          View all plans
          <ArrowRightIcon size={16} className="ml-1" />
        </button>
      </div>
    </div>;
};
export default SubscriptionPlans;